<div class="space-y-10">
  <!-- other names -->
  <div>
    <app-text-chip-input [formGroup]="eventForm" id="names" label="Nomes conhecidos" [maxChips]="3"
                         [formError]="apiErrors.get('names')"></app-text-chip-input>
    <small class="text-amber-700">* Insira apelidos e/ou nomes de familiares para encontrar
      mais resultados durante a pesquisa. Este campo permite a adição de até 3 nomes.</small></div>

  <!-- Gender-->
  <div>
    <app-select-input [formGroup]="eventForm" [options]="genders" id="gender"
                      label="Gênero (Obrigatório)" [formError]="apiErrors.get('gender')"></app-select-input>
  </div>

  <!--birthday-->
  <div>
    <app-calendar-input [formGroup]="eventForm" [maxDate]="maxBirthDate" id="birthDate"
                        label="Data de Nascimento (Obrigatório)"
                        [formError]="apiErrors.get('birthDate')"></app-calendar-input>
  </div>
</div>

